import { CLEAR_USER_SUGGESTION } from 'constants/action_types'

export function doClearUserSuggestion() {
  return {
    type: CLEAR_USER_SUGGESTION,
  }
}
